import { action, computed, thunk } from "easy-peasy";
import API from "API";
import { fixDates4Post } from "Utils/";

export const ACTION_TYPES = {
  FAILED: 1,
  FINISHED: 2,
  FETCHING_DATA: 5,
  FETCHED_DATA: 6,
};

const GeneralReportModel = (api) => {
  return {
    process: null,
    error: null,
    data: [],
    filters: {},

    setProcess: action((state, payload) => {
      state.process = payload;
    }),

    setError: action((state, payload) => {
      state.error = payload;
      state.process = ACTION_TYPES.FAILED;
    }),

    setData: action((state, payload) => {
      state.data = payload;
    }),

    setFilters: action((state, payload) => {
      state.filters = payload;
    }),

    fetch: thunk(async (actions, payload, helpers) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const data = await API.get(`/reports/${api}`, { params: payload });
        actions.setData(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while fetching data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),
  };
};

export default GeneralReportModel;
